/**
 * Get single or plural text based on count
 * @param { number } count number of items
 * @param { string } single text for a single item
 * @param { string | undefined } plural optional text for multiple items
 * @returns { string } the pluralized text if items > 1, if plural is undefined 's' will be appended
 */
export function pluralize(count, single, plural) {
    return count === 1 ? single : plural === undefined ? `${single}s` : plural;
}
